import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModuleForCalendar = new LazyModule(
    () => import(/* webpackChunkName: "RunAfterRequestCalendar" */ './runAfterRequestCalendar'),
    { name: 'RunAfterRequestCalendar' }
);
const lazyModuleForPeople = new LazyModule(
    () => import(/* webpackChunkName: "RunAfterRequestPeople" */ './runAfterRequestPeople'),
    { name: 'RunAfterRequestPeople' }
);
export const lazyRunAfterRequestCalendar = new LazyAction(
    lazyModuleForCalendar,
    m => m.runAfterRequestCalendar
);

export const lazyRunAfterRequestPeople = new LazyAction(
    lazyModuleForPeople,
    m => m.runAfterRequestPeople
);
